import React, { useState, useEffect, useCallback } from "react";
import {
  Typography,
  Grid,
  Box,
  Input,
  TextField,
  Menu,
  MenuItem,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  ListItemIcon,
  CircularProgress,
  Tabs,
  Tab,
  Popover,
} from "@mui/material";

import {
  People,
  Settings,
  PlaylistAdd,
  GroupAdd,
  SmartToy,
  Dashboard,
  Assessment,
  Style as StyleIcon,
  ExpandMore as ExpandMoreIcon,
  Settings as SettingsIcon,
  Person as PersonIcon,
  Logout as LogoutIcon,
  Delete as DeleteIcon,
  Edit as EditIcon,
} from "@mui/icons-material";
import { oauthUserMgmt, tenant } from "../../utils/utils";
import loginImage from "../../../resources/images/vyoog.png";
import User from "./User";
import TagConfig from "./TagConfig";
import BoardConfig from "./BoardConfig";
import ReportsConfig from "./ReportsConfig"
import FieldsConfig from "./FieldsConfig"
import BoardSelection from "./BoardSelection";
import Invite from "./Invite";
import AccessDenied from "../../ui/AccessDenied"
import {
  fetchChatGPTResponse,
  userLogOut,
  headers,
  hasRole,
  loginMemberId,
} from "../../utils/utils";
import { MentionsInput, Mention } from "react-mentions";
import { useNavigate } from "react-router-dom";
const Header = ({
  isBoardAllow,
  setIsBoardAllow,
  setTicketStatus,
  fetchLabel,
  fetchAllMemberFromTicket,
  memberList,
  tagsList,
  setTagsList,
  ticketStatus,
  setOpenSettingsDialog,
  openSettingsDialog,
  LoadIcon,
  handleSettingsClick,
  onSearch,
  displayAlertMessage,
  reportLoaded,
  setReportLoaded
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [username, setUsername] = useState("");
  const [isInputVisible, setIsInputVisible] = useState(false);
  const [text, setText] = useState("");
  const [ticketJsonData, setTicketJsonData] = useState({});
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [boards, setBoards] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [editedLabel, setEditedLabel] = useState("");
  const [value, setValue] = useState(0);
  const openMenu = Boolean(anchorEl);
  const [error, setError] = useState("");

  const handleMenuClick = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);
  const handleSettingsDialogClose = () => setOpenSettingsDialog(false);
  const navigate = useNavigate();
  // Group members under "Member"
  const groupedUsers = {
    User: memberList.map((user) => ({ id: user.id, display: user.fullName })),
  };

  // Group tags under "Tags"
  const groupedTags = {
    Tags: tagsList.map((tag) => ({ id: tag.id, display: tag.value })),
  };

  // Merge both groups into one object
  const groupedData = { ...groupedTags, ...groupedUsers };

  const handleChange = (event, newValue, newPlainTextValue, mentions) => {
    setText(newValue);
    let formattedText = newPlainTextValue;
    mentions.forEach((mention) => {
      console.log("mention", mention)
      // Find the correct mention object from mentionData to get the group
      const foundMention = mentionData.find((item) => item.id.toString() === mention.id.toString());
      const group = foundMention ? foundMention.group : "Unknown";
      
      const mentionFormat = `${group}='${mention.id}'`;
      formattedText = formattedText.replace(mention.display, mentionFormat);
    });
    console.log(formattedText)
    if (formattedText !== "@" && formattedText !== "") {
      console.log("DONE" + formattedText)
      onSearch(formattedText)
    }
  };  
  const mentionData = Object.entries(groupedData).flatMap(([group, items]) => [
    { id: `group-${group}`, display: group, isGroup: true }, // Group Header
    ...items.map((item) => ({ ...item, group })),
  ]);

  useEffect(() => {

    if (!ticketJsonData) return;
  }, [ticketJsonData]);

  const fetchWorkFlow = useCallback(async () => {
    if (localStorage.getItem("board")) {
      const response = await fetch(
        process.env.REACT_APP_TICKET_SERVER +
        "/ticket/workFlow?board=" +
        localStorage.getItem("board"),
        {
          method: "GET",
          headers: headers(),
        },
      );
      if (response.ok) {
        const result = await response.json();
        setTicketJsonData(result);

        setTicketStatus(
          result.boards && result.boards.length > 0 ? result.boards : [],
        );

        const isMember = result.members?.some(
          (memId) => memId === loginMemberId(),
        );
        setIsBoardAllow(hasRole("ADMIN") || isMember);
      }
    }
  }, [setTicketJsonData, setTicketStatus, setIsBoardAllow]);

  const fetchBoards = useCallback(async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_SYS_CONFIG_MGMT + "/systemConfig/config?name=Board&active=true",
        { method: "GET", headers: headers() },
      );
      const data = await response.json();
      setBoards(data);
    } catch (error) {
      console.error("Error fetching boards.", error);
    }
  }, [setBoards]);

  useEffect(() => {
    const storedUsername = localStorage.getItem("vyg_login_user");

    if (storedUsername) setUsername(storedUsername);

    fetchWorkFlow();
    fetchBoards();
  }, [fetchWorkFlow, fetchBoards]);


  useEffect(() => {
    const intervalId = setInterval(() => {
      fetchLabel();
      fetchAllMemberFromTicket();
    }, 60000);

    return () => clearInterval(intervalId);
  }, [fetchLabel, fetchAllMemberFromTicket]);

  const handleWorkEditClick = (id, label) => {
    setEditingId(id);
    setEditedLabel(label);
  };

  const handleWorkFlowEditSave = (id) => {
    setTicketStatus((prev) => {
      const updatedStatus = prev.map((item) =>
        item.id === id ? { ...item, label: editedLabel } : item,
      );
      sendTicketStatusToServer(updatedStatus);
      return updatedStatus;
    });
    setEditingId(null);
  };

  const handleBoardSwitch = () => {
    setIsPopupOpen(true);
  };

  const handleDeleteWorflow = async (id) => {
    setTicketStatus((prevStatus) => {
      const updatedStatus = prevStatus
        .filter((item) => item.id !== id)
        .map((status) => ({
          ...status,
          ticketList: [],
        }));

      sendTicketStatusToServer(updatedStatus);

      return [...updatedStatus];
    });
  };

  const handleAddWorkFlow = async (newLabel) => {
    if (newLabel) {
      const colorContent = `Provide only the Material UI color code that best represents the status '${newLabel}'. Avoid yellow colors and ensure the color is readable. Do not include any additional text—only the exact color code.`;
      const colorCode = await fetchChatGPTResponse(colorContent);

      const iconContent = `Provide only the material ui icon name from https://mui.com/material-ui/material-icons/ for the title '${newLabel}' without any additional text.`;

      let iconName = await fetchChatGPTResponse(iconContent);
      iconName = iconName.charAt(0).toUpperCase() + iconName.slice(1);

      setTicketStatus((prevStatus) => {
        const newId = prevStatus.length
          ? prevStatus[prevStatus.length - 1].id + 1
          : 1;
        const newStatus = {
          id: newId,
          label: newLabel,
          color: colorCode,
          icon: iconName,
          ticketList: [],
          pageNumber: 0,
        };

        const updatedStatus = [...prevStatus, newStatus];
        sendTicketStatusToServer(updatedStatus);

        return updatedStatus;
      });

      setIsInputVisible(false);
    }
  };

  const TabPanel = ({ children, value, index }) => {
    return (
      <div hidden={value !== index}>
        {value === index && (
          <Box p={3}>
            <div>{children}</div>
          </Box>
        )}
      </div>
    );
  };

  const sendTicketStatusToServer = async (latestTicketStatus) => {
    const updatedData = {
      ...ticketJsonData,
      boards: latestTicketStatus.map((status) => ({
        ...status,
        ticketList: [],
        pageNumber: 0,
      })),
      members: ticketJsonData.members || [loginMemberId()],
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_TICKET_SERVER}/ticket/workFlowUpdate?board=${localStorage.getItem("board")}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...headers(),
          },
          body: JSON.stringify(updatedData),
        },
      );

      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response.status}`);

      const result = await response.json();
      console.log("Successfully sent ticket status:", result);

      fetchWorkFlow();
    } catch (error) {
      console.error("Error sending ticket status:", error);
    }
  };

  const workFlowGenerate = async () => {
    setLoading(true);

    const currentBoard =
      boards &&
      boards.length > 0 &&
      boards.filter(
        (board) =>
          board.id.toString() === localStorage.getItem("board").toString(),
      );
    const colorContent = `'${currentBoard[0]["value"]}' workflow list of stages i need comma separate . i need exact output without additional text`;
    const workflowList = await fetchChatGPTResponse(colorContent);
    const workflowArray = workflowList.split(",");

    for (const item of workflowArray) {
      const trimmedItem = item.trim();
      await handleAddWorkFlow(trimmedItem);
    }
    setLoading(false);
  };

  const tabHandleChange = (event, newValue) => {
    setValue(newValue);
  };


  const [email, setEmail] = useState("");
  const [anchorEl1, setAnchorEl1] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");
  const handleOpen = (event) => {
    setAnchorEl1(event.currentTarget);
  };

  // Close popup
  const handleClose = () => {
    setAnchorEl1(null);
    setEmail(""); // Reset input on close
    setError("");
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleEmailChange = (e) => {
    setSuccessMessage("");
    const newEmail = e.target.value;
    setEmail(newEmail);

    // Validate email
    if (!newEmail) {
      setError("Email is required");
    } else if (!validateEmail(newEmail)) {
      setError("Invalid email format");

    } else {
      setError("");
    }
  };

  // Assign Role to User
  const assignRoleToUser = async (userId) => {
    try {
      // Fetch role ID by name
      const roleResponse = await fetch(`${process.env.REACT_APP_USER_MGMT}/admin/realms/eVyoog/roles/USER`, {
        headers: {
          ...oauthUserMgmt(),
          "Content-Type": "application/json",
        },
      });

      if (!roleResponse.ok) throw new Error("Failed to fetch role");
      const role = await roleResponse.json();

      // Assign role to user
      const assignResponse = await fetch(`${process.env.REACT_APP_USER_MGMT}/admin/realms/eVyoog/users/${userId}/role-mappings/realm`, {
        method: "POST",
        headers: {
          ...oauthUserMgmt(),
          "Content-Type": "application/json",
        },
        body: JSON.stringify([{ id: role.id, name: role.name }]),
      });

      if (!assignResponse.ok) throw new Error("Failed to assign role");

      setSuccessMessage("User invited..!");
    } catch (error) {
      setError("Error assigning role.");
    }
  };

  // Handle Send button click
  // const handleSend = async () => {

  //   if (error || !email) return;

  //   try {

  //     const createUserResponse = await fetch(`${process.env.REACT_APP_USER_MGMT}/admin/realms/eVyoog/users`, {
  //       method: "POST",
  //       headers: {
  //         ...oauthUserMgmt(),
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({
  //         username: email,
  //         email: email,
  //         enabled: true,
  //         emailVerified: true,
  //         attributes: { tenant: tenant() },
  //       }),
  //     });



  //     if (!createUserResponse.ok) throw new Error(createUserResponse.json().errorMessage);

  //     // Fetch user ID by email
  //     const getUserResponse = await fetch(`${process.env.REACT_APP_USER_MGMT}/admin/realms/eVyoog/users?email=${email}`, {
  //       headers: {
  //         ...oauthUserMgmt(),
  //         "Content-Type": "application/json",
  //       },
  //     });

  //     if (!getUserResponse.ok) throw new Error("Failed to fetch user ID");

  //     const users = await getUserResponse.json();
  //     if (users.length === 0) throw new Error("User not found");

  //     const userId = users[0].id;

  //     // Assign role to user
  //     await assignRoleToUser(userId);

  //     await sendMailNotification(email);
  //     memberAdd(userId)
  //   } catch (err) {
  //     setError(err.message);
  //   }

  //   handleClose();

  // };

  const handleSend = async () => {
    if (error || !email) return;
  
    try {
      // Step 1: Check if user already exists
      const getUserResponse = await fetch(
        `${process.env.REACT_APP_USER_MGMT}/admin/realms/eVyoog/users?email=${email}`,
        {
          headers: {
            ...oauthUserMgmt(),
            "Content-Type": "application/json",
          },
        }
      );
  
      if (!getUserResponse.ok) throw new Error("Failed to fetch user");
  
      const users = await getUserResponse.json();
      let userId;
  
      if (users.length > 0) {
        // User already exists
        userId = users[0].id;
      } else {
        // Step 2: Create new user
        const createUserResponse = await fetch(
          `${process.env.REACT_APP_USER_MGMT}/admin/realms/eVyoog/users`,
          {
            method: "POST",
            headers: {
              ...oauthUserMgmt(),
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              username: email,
              email: email,
              enabled: true,
              emailVerified: true,
              attributes: { tenant: tenant() },
            }),
          }
        );
  
        if (!createUserResponse.ok) {
          const errorData = await createUserResponse.json();
          throw new Error(errorData.errorMessage || "Failed to create user");
        }
  
        // Fetch the newly created user
        const newUserResponse = await fetch(
          `${process.env.REACT_APP_USER_MGMT}/admin/realms/eVyoog/users?email=${email}`,
          {
            headers: {
              ...oauthUserMgmt(),
              "Content-Type": "application/json",
            },
          }
        );
  
        if (!newUserResponse.ok) throw new Error("Failed to fetch newly created user");
  
        const newUsers = await newUserResponse.json();
        if (newUsers.length === 0) throw new Error("User not found after creation");
  
        userId = newUsers[0].id;
      }
  
      // Step 3: Assign role to user
      await assignRoleToUser(userId);
  
      // Step 4: Send mail notification
      await sendMailNotification(email);
  
      // Step 5: Add member
      memberAdd(userId);
  
    } catch (err) {
      setError(err.message);
    }
  
    handleClose();
  };
  

  const memberAdd = async (userId) => {
    console.log("Invitation memberAdd.", ticketJsonData);

    try {
      const updatedData = {
        ...ticketJsonData,
        members: [...ticketJsonData.members, userId],
      };

      const response = await fetch(
        `${process.env.REACT_APP_TICKET_SERVER}/ticket/workFlowUpdate?board=" +
          localStorage.getItem("board"),`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...headers(),
          },
          body: JSON.stringify(updatedData),
        },
      );

      if (response.ok) {
        console.log("success to update ticket workflow.");
      } else {
        console.error("Failed to update ticket workflow.");
      }
    } catch (error) {
      console.error("Error member add:", error);
    }
  };

  const sendMailNotification = async (email) => {
    try {

      const response = await fetch(
        `${process.env.REACT_APP_NOTIFICATION}/notification/save?templatePath=/opt/eVyoog/systemconfig/mailTemplate/Ticket/InviteUser.html`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...headers(),
          },
          body: JSON.stringify({
            recipient: email,  // Make sure this is the correct recipient email
            message: "",
            type: "EMAIL",
            subject: `Invite User Details`,
            status: "PENDING",

          }),
        },
      );

      if (!response.ok) {
        console.error("Failed to send email notification.");
      } else {
        console.log("Email notification sent successfully.");
      }
    } catch (error) {
      console.error("Error sending email:", error);
    }
  };


  return (
    <div>
      <br />
      <Grid container spacing={2}>
        <Grid item xs={1} />

        <Grid item xs={2}>
          <img
            src={loginImage}
            alt="Login"
            style={{ width: "35%", marginBottom: "1rem" }}
          />
        </Grid>

        <Grid item xs={2}>
          <Button
            color="inherit"
            variant="outlined"
            sx={{ marginRight: 2 }}
            onClick={handleBoardSwitch}
          >
            Switch to Board
          </Button>
        </Grid>

        <Grid item xs={2}>
          <Box display="flex" alignItems="center">
            <StyleIcon fontSize="inherit" />
            <Typography variant="button" sx={{ ml: 1 }}>
              {boards?.length > 0 &&
                boards.find(
                  (board) =>
                    board.id.toString() ===
                    localStorage.getItem("board")?.toString(),
                )?.value}
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={1}>
          <Button variant="outlined" color="primary" onClick={handleOpen}>
            Invite
          </Button>
          <Popover
            open={Boolean(anchorEl1)}
            anchorEl={anchorEl1}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          >
            <Box sx={{ p: 2, width: 250 }}>
              <Input
                placeholder="Enter Email"
                value={email}
                onChange={handleEmailChange}
                fullWidth
              />
              {error && (
                <Typography color="error" sx={{ fontSize: "12px", mt: 1 }}>
                  {error}
                </Typography>
              )}
              {successMessage && (
                <Typography color="success" sx={{ fontSize: "12px", mt: 1 }}>
                  {successMessage}
                </Typography>
              )}


              <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
                <Button
                  onClick={handleSend}
                  size="small"
                  variant="contained"
                  color="primary"
                  disabled={!!error || !email}
                  sx={{ textTransform: "none", borderRadius: "8px", px: 2 }}
                >
                  Send Invite
                </Button>
              </Box>
            </Box>
          </Popover>
        </Grid>

        <Grid item xs={3}>
          <Grid container spacing={4}>


            <Grid item xs={5}>
              <MentionsInput
                value={text}
                onChange={handleChange}
                style={{
                  control: { fontSize: 14, width: "100%" },
                  highlighter: { padding: 12, border: "none", outline: "none" },
                  input: {
                    padding: 12,
                    border: "none",
                    borderBottom: "2px solid #1fa3c6", // Add bottom border
                    outline: "none"
                  },
                  suggestions: {
                    zIndex: 9999,
                    list: {
                      maxHeight: "300px",
                      width: "300px",
                      overflowY: "auto",
                      backgroundColor: "white",
                      border: "1px solid rgba(0,0,0,0.15)",
                      borderRadius: "4px",
                      boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                      zIndex: 9999,
                      position: "fixed",
                    },
                    item: {
                      padding: "10px",
                      cursor: "pointer",
                      textAlign: "left",
                      "&focused": { backgroundColor: "#1fa3c6", color: "white" },
                    },
                  },
                }}
                placeholder="Search"
                maxLength={1000}
              >
                <Mention
                  trigger="@"
                  data={mentionData}
                  renderSuggestion={(suggestion, search, highlightedDisplay, index) =>
                    suggestion.isGroup ? (
                      <Typography
                        key={index}
                        sx={{
                          fontSize: "14px",
                          fontWeight: "bold",
                          color: "GrayText",
                          borderRadius: "4px",

                          minWidth: "120px",
                          textAlign: "center",
                          outline: "none",
                        }}
                      >
                        {suggestion.display}
                      </Typography>
                    ) : (
                      <div
                        key={index}
                        style={{
                          padding: "5px 1px",
                          cursor: "pointer",
                          borderRadius: "6px",
                          fontSize: "11px",
                          minWidth: "120px",
                          textAlign: "left",
                          outline: "none",
                          boxShadow: "none",
                          border: "none",
                        }}
                      >
                        {suggestion.display}
                      </div>
                    )
                  }
                />
              </MentionsInput>
            </Grid>

            <Grid item xs={3}>
            <MenuItem onClick={() =>  navigate("/sub-dashboard")}>
            <ListItemIcon>
            <Dashboard fontSize="small" />
            </ListItemIcon>
           
          </MenuItem>
          </Grid>

            <Grid item xs={4}>
              <button
                style={{
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "transparent",
                  border: "none",
                  color: "inherit",
                  cursor: "pointer",
                  fontSize: "1rem",
                }}
                onClick={handleMenuClick}
                aria-expanded="false"
              >
                <PersonIcon />
                {username}
                <ExpandMoreIcon style={{ marginLeft: "8px" }} />
              </button>

              <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={openMenu}
                onClose={handleMenuClose}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    mt: 1.5,
                    width: 200,
                    "& .MuiAvatar-root": {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    "&::before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                    },
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <MenuItem onClick={handleSettingsClick}>
                  <ListItemIcon>
                    <SettingsIcon fontSize="small" />
                  </ListItemIcon>
                  Settings
                </MenuItem>

                <MenuItem onClick={() => userLogOut()}>
                  <ListItemIcon>
                    <LogoutIcon fontSize="small" />
                  </ListItemIcon>
                  Logout
                </MenuItem>
                <MenuItem onClick={() =>  navigate("/main-dashboard")}>
                  <ListItemIcon>
                  <Dashboard fontSize="small" />
                  </ListItemIcon>
                  Dashboard
                </MenuItem>
              </Menu>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Dialog
        open={openSettingsDialog}
        onClose={handleSettingsDialogClose}
        fullWidth
        maxWidth="lg"
        PaperProps={{
          style: {
            marginTop: "0",
            position: "absolute",
            top: 50,
          },
        }}
      >
        <DialogTitle>
          <div style={{ display: "flex", alignItems: "center" }}>
            <SettingsIcon style={{ marginRight: "8px" }} />
            <Typography variant="body2" color="text.secondary">
              <b>Settings</b>
            </Typography>
          </div>
        </DialogTitle>

        <DialogContent>
          <Box sx={{ bgcolor: "background.paper", borderRadius: 2 }}>
            <Tabs
              value={value}
              onChange={tabHandleChange}
              variant="fullWidth"
              textColor="secondary"
              indicatorColor="secondary"
              sx={{
                "& .MuiTab-root": {
                  fontWeight: "bold",
                  textTransform: "none",
                },
                "& .Mui-selected": {
                  color: "primary.main",
                },
              }}
            >

              <Tab icon={<People />} label="Users" />
              <Tab icon={<Settings />} label="Board Settings" />
              <Tab icon={<PlaylistAdd />} label="Add / Remove Boards" />
              <Tab icon={<GroupAdd />} label="Invite Members" />
              <Tab icon={<Assessment />} label="Reports" />
              <Tab icon={<Assessment />} label="Fields" />
            </Tabs>

            <Box
              sx={{ bgcolor: "white", p: 1, borderRadius: "0 0 12px 12px" }}
            >

              <TabPanel value={value} index={0}>
                {hasRole("ADMIN") ?
                  <User fetchAllMemberFromTicket={fetchAllMemberFromTicket} />
                  :
                  <AccessDenied />

                }
              </TabPanel>

              <TabPanel value={value} index={1}>

                <>
                  <TagConfig tags={tagsList} setTags={setTagsList} />

                  <hr className="hr" />

                  {hasRole("ADMIN") ? (
                    <>
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <Typography variant="h5" gutterBottom>
                          Workflow
                        </Typography>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={workFlowGenerate}
                          startIcon={<SmartToy />}
                        >
                          AI Generate
                        </Button>
                      </Box>

                      <br />

                      <Grid
                        container
                        spacing={2}
                        justifyContent="center"
                        alignItems="center"
                      >
                        {ticketStatus.map((item) => (
                          <Grid item key={item.id}>
                            {editingId === item.id ? (
                              <TextField
                                value={editedLabel}
                                onChange={(e) => setEditedLabel(e.target.value)}
                                onBlur={() => handleWorkFlowEditSave(item.id)}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    handleWorkFlowEditSave(item.id);
                                  }
                                }}
                                autoFocus
                                size="small"
                              />
                            ) : (
                              <Button
                                variant="outlined"
                                sx={{
                                  color: item.color,
                                  borderColor: item.color,
                                  "&:hover": {
                                    backgroundColor: "transparent",
                                    color: item.color,
                                    borderColor: item.color,
                                  },
                                }}
                                startIcon={<LoadIcon iconName={item.icon} />}
                                endIcon={
                                  <>
                                    <IconButton
                                      size="small"
                                      onClick={() =>
                                        handleWorkEditClick(item.id, item.label)
                                      }
                                    >
                                      <EditIcon fontSize="small" />
                                    </IconButton>
                                    <IconButton
                                      size="small"
                                      onClick={() => handleDeleteWorflow(item.id)}
                                    >
                                      <DeleteIcon fontSize="small" />
                                    </IconButton>
                                  </>
                                }
                              >
                                {item.label}
                              </Button>
                            )}
                          </Grid>
                        ))}

                        {loading ? (
                          <>
                            {" "}
                            <CircularProgress size={30} color="inherit" />{" "}
                          </>
                        ) : (
                          ""
                        )}

                        <Grid
                          item
                          style={{ position: "relative", width: "120px" }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: "100%",
                            }}
                            onMouseEnter={() => setIsInputVisible(true)}
                          >
                            {!isInputVisible ? (
                              <Button
                                variant="contained"
                                color="success"
                                style={{ minWidth: "100%" }}
                              >
                                +
                              </Button>
                            ) : (
                              <TextField
                                variant="outlined"
                                size="small"
                                placeholder="Enter new item"
                                onBlur={(e) => {
                                  handleAddWorkFlow(e.target.value);
                                  setIsInputVisible(false);
                                }}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    handleAddWorkFlow(e.target.value);
                                  }
                                }}
                                sx={{ width: "100%" }}
                              />
                            )}
                          </div>
                        </Grid>
                      </Grid>
                    </>
                  ) :
                    <AccessDenied />}
                </>


              </TabPanel>

              <TabPanel value={value} index={2}>
                {hasRole("ADMIN") ?
                  <BoardConfig
                    boards={boards}
                    setBoards={setBoards}
                    fetchBoards={fetchBoards}
                  />
                  :
                  <AccessDenied />
                }
              </TabPanel>

              <TabPanel value={value} index={3}>
                {isBoardAllow ? (
                  <Invite
                    ticketJsonData={ticketJsonData}
                    setTicketJsonData={setTicketJsonData}
                  />
                ) : (
                  <AccessDenied />
                )}
              </TabPanel>
              <TabPanel value={value} index={4}>
                {hasRole("ADMIN") ?
                  <ReportsConfig memberList={memberList} tagsList={tagsList} ticketStatus={ticketStatus} displayAlertMessage={displayAlertMessage} reportLoaded={reportLoaded} setReportLoaded={setReportLoaded}/>
                  :
                  <AccessDenied />

                }
              </TabPanel>
              <TabPanel value={value} index={5}>
                {hasRole("ADMIN") ?
                  <FieldsConfig memberList={memberList} tagsList={tagsList} ticketStatus={ticketStatus} displayAlertMessage={displayAlertMessage}/>
                  :
                  <AccessDenied />

                }
              </TabPanel>
            </Box>
          </Box>
        </DialogContent>

        <DialogActions></DialogActions>
      </Dialog>

      {isPopupOpen && (
        <BoardSelection
          open={isPopupOpen}
          onClose={() => setIsPopupOpen(false)}
        />
      )}
    </div>
  );
};

export default Header;
